import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!impersonating) return null;

  return (
    <div style={{
      position: 'sticky', top: 0, left: 0, right: 0, zIndex: 9999,
      padding: '6px 20px',
      background: 'linear-gradient(90deg, #F5A623 0%, #E8943E 100%)',
      color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
      fontFamily: "'DM Mono', monospace", fontSize: 12,
      boxShadow: '0 2px 8px rgba(245,166,35,0.3)',
    }}>
      <span style={{ fontWeight: 600 }}>👁 IMPERSONATING</span>
      <span>{impersonating.name}</span>
      <span style={{ opacity: 0.7 }}>({impersonating.email})</span>
      <span style={{
        padding: '1px 6px', borderRadius: 4,
        background: 'rgba(255,255,255,0.2)', fontSize: 12,
      }}>{impersonating.role || 'annotator'}</span>
      <button onClick={() => { stopImpersonating(); navigate('/admin'); }} style={{
        padding: '2px 10px', fontSize: 10,
        background: 'rgba(255,255,255,0.2)', color: '#fff',
        border: '1px solid rgba(255,255,255,0.4)', borderRadius: 4,
        cursor: 'pointer', fontFamily: "'DM Mono', monospace", fontWeight: 600,
      }}>Exit</button>
    </div>
  );
}
